import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterHistoricalCashFlowView.
 * @extends JetView
 */
export default class FilterHistoricalCashFlowView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Date range picker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Single date picker
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Country selection dropdown
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only country selection
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry country-hide',
                        },
                        {
                            view: 'richselect', // Currency selection dropdown
                            name: 'CurrencySelect',
                            localId: 'currencies:combo',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Currency options
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Type detail selection
                            name: 'TypeDetail',
                            localId: 'typeDetail:combo',
                            label: _('Tipo de Detalle'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Type detail options
                        },
                        { id: 'grav2', gravity: 2 },
                        { id: 'grav3', gravity: 2 },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    height: document.body.offsetWidth < 500 ? 100 : 0,
                    cols: [
                        {
                            view: 'radio', // Type selection radio buttons
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            value: 0,
                            options: [
                                { id: 0, value: _('Detallado') }, // Detailed option
                                { id: 1, value: _('Totales') }, // Total option
                            ],
                        },
                        { id: 'grav4', gravity: 2 },
                        { id: 'grav5', gravity: 2 },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav6' },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                                $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('historicalCashFlow:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 350 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };

        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements based on screen size
            }
            if (profile.typeDate !== 2) {
                delete filterdata['Date']; // Remove date if not applicable
            } else {
                if (true) {
                    delete filterdata['Datepicker']; // Remove datepicker if applicable
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide elements based on screen size
                $$('grav3').hide();
                $$('grav4').hide();
                $$('grav5').hide();
                $$('grav6').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Show/hide date fields based on profile
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
